import { httpClient } from '../lib/http-client';
import { TemplateResposta } from '../types';

/**
 * Service para gerenciamento de templates de resposta
 */
export class TemplatesService {
  static async getTemplates(): Promise<TemplateResposta[]> {
    return httpClient.get<TemplateResposta[]>('/api/templates-resposta');
  }

  static async getTemplate(id: number): Promise<TemplateResposta> {
    return httpClient.get<TemplateResposta>(`/api/templates-resposta/${id}`);
  }

  static async createTemplate(data: Partial<TemplateResposta>): Promise<TemplateResposta> {
    return httpClient.post<TemplateResposta>('/api/templates-resposta', data);
  }

  static async updateTemplate(id: number, data: Partial<TemplateResposta>): Promise<TemplateResposta> {
    return httpClient.put<TemplateResposta>(`/api/templates-resposta/${id}`, data);
  }

  static async deleteTemplate(id: number): Promise<{ success: boolean; message?: string }> {
    return httpClient.delete<{ success: boolean; message?: string }>(`/api/templates-resposta/${id}`);
  }

}

